import { Modal } from "antd";
import Styles from "../css/vehicleModals.module.scss";
import Caution from "../../../../assets/cautionicon.svg";
import { useAppSelector } from "customHooks/useAppSelector";
import { formatAmount } from "utils/currency";
import dropdownIconImg from "assets/Vector copy 2.svg";
import arrowUpImg from "assets/arrowupicon.svg";
import { useState } from "react";
import moment from "moment";

const MerchantInspectionSuccessModal = (props: any) => {
  const [openVehicleDetails, setOpenVehicleDetails] = useState(false)
  const [openVehicleInstruction, setOpenVehicleInstruction] = useState(false)
  // const vehicleData = props.savePaymentResponse;
  const vehicleData = useAppSelector(
    (state) => state?.vehicleFinance?.vehicleInfo
  );

  const toggleVehicleInstruction = () => {
    setOpenVehicleInstruction(!openVehicleInstruction)
  }
  const toggleVehicleDetails = () => {
    setOpenVehicleDetails(!openVehicleDetails)
  }
  return (
    <div>
      <Modal
        title="Basic Modal"
        centered
        destroyOnClose={true}
        width={500}
        open={props.isModalOpen}
        onOk={props.handleOk}
        // onCancel={props.handleCancel}
        className={Styles.customModal}
      >
        <div className={Styles.modalContentVerification} style={{ paddingTop: '0em' }}>
          <div className={Styles.cautionDiv} style={{ marginTop: '0em', paddingTop: '1em' }}>
            <img
              src={Caution}
              className={Styles.cautionIconSmall}
              alt="horse"
            />
          </div>
          <div style={{ textAlign: "center" }} className={Styles.title}>
            Request Successfully Submitted
          </div>
          {/* <div style={{ textAlign: "center" }} className={Styles.desc}>
            Kindly visit the vendor location for you to complete your inspection
          </div> */}

          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', cursor: 'pointer' }} onClick={toggleVehicleInstruction}>
              <div className={Styles.title} style={{ fontSize: '1em' }}>Inspection instruction</div>
              <img
                src={openVehicleInstruction ? dropdownIconImg : arrowUpImg}
                alt="sidebarIcon"
                style={{ width: '16px' }}
              />
            </div>
            {openVehicleInstruction &&
              <div>
                <div className={Styles.merchantBox}
                  style={{
                    background: "white",
                    // height: "55vh",
                    overflow: "scroll",
                    paddingLeft: '0em',
                    paddingTop: '0em'
                  }}>
                  <div className={Styles.descThree}>Please note that you can inspect the vehicle requested within 5 days from request on QuickBucks.</div>
                  <div className={Styles.descThree}>To inspect your Vehicle, kindly visit the pick-up location within 72 hours of completing your request with the following:</div>

                  <div className={Styles.top} style={{ paddingLeft: '0.5em' }}>
                    <div className={Styles.descThree}><span style={{ height: '5px', width: '5px', borderRadius: '5px', background: '#5D6B82', display: 'inline-flex', marginRight: '0.5em' }} />A Government issued ID i.e. International Passport, National ID Card, Drivers Licence or Voter’s Card</div>
                    <div className={Styles.descThree}><span style={{ height: '5px', width: '5px', borderRadius: '5px', background: '#5D6B82', display: 'inline-flex', marginRight: '0.5em' }} />Transaction ID (Please note that this ID expires after 72 hours)</div>
                    <div className={Styles.descThree}><span style={{ height: '5px', width: '5px', borderRadius: '5px', background: '#5D6B82', display: 'inline-flex', marginRight: '0.5em' }} />Last four (4) digits of your Telephone Number</div>
                  </div>

                  <div>
                    <div className={Styles.merchantRow}>
                      <div className={Styles.merchantHalf}>Request Date </div>
                      <div className={Styles.merchantHalfRight}>
                        {moment(vehicleData?.CreatedOn).format("Do-MMM-YYYY")}
                      </div>
                    </div>
                    <div className={Styles.borderLineThree} />

                    <div className={Styles.merchantRow}>
                      <div className={Styles.merchantHalf}>Expiry Date </div>
                      <div className={Styles.merchantHalfRight}>
                        {moment(vehicleData?.ExpiredOn).format("Do-MMM-YYYY")}
                      </div>
                    </div>
                    <div className={Styles.borderLineThree} />

                    <div className={Styles.merchantRow}>
                      <div className={Styles.merchantHalf}>Car Location </div>
                      <div className={Styles.merchantHalfRight}>
                        {vehicleData?.Meta?.CarDetails?.Location}
                      </div>
                    </div>
                    <div className={Styles.borderLineThree} />

                    <div className={Styles.merchantRow}>
                      <div className={Styles.merchantHalf}>Car Inspection Location </div>
                      <div className={Styles.merchantHalfRight}>
                        {vehicleData?.Meta?.CarDetails?.LocationAddress}
                      </div>
                    </div>
                    <div className={Styles.borderLineThree} />

                    <div className={Styles.merchantRow}>
                      <div className={Styles.merchantHalf}>Vendor Name</div>
                      <div className={Styles.merchantHalfRight}>
                        {vehicleData?.MerchantName}
                      </div>
                    </div>
                    <div className={Styles.borderLineThree} />

                    <div className={Styles.merchantRow}>
                      <div className={Styles.merchantHalf}>Contact Number</div>
                      <div className={Styles.merchantHalfRight}>
                        {vehicleData?.Meta?.CarDetails?.ContactNumber}
                      </div>
                    </div>
                    <div className={Styles.borderLineThree} />
                  </div>

                  <div className={Styles.descThree}>"Kindly note that the offer letter, vehicle inspection details and other details have been sent to your email"</div>
                </div>
              </div>
            }
          </div>


          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '1em', cursor: 'pointer' }} onClick={toggleVehicleDetails}>
              <div className={Styles.title} style={{ fontSize: '1em' }}>Vehicle details</div>
              <img
                src={openVehicleDetails ? dropdownIconImg : arrowUpImg}
                alt="sidebarIcon"
                style={{ width: '16px' }}
              />
            </div>

            {openVehicleDetails &&
              <div className={Styles.merchantBox}
                style={{
                  background: "white",
                  // height: "55vh",
                  overflow: "scroll",
                  paddingLeft: '0em',
                  paddingTop: '0em'
                }}>
                {/* <div className={Styles.desc}>
              Details of Vehicle Finance on QuickBucks request:
            </div> */}
                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>Transaction ID</div>
                  <div className={Styles.merchantHalfRight}>{vehicleData?.Id}</div>
                </div>
                <div className={Styles.borderLineThree} />

                {/* <div className={Styles.merchantRow}>
              <div className={Styles.merchantHalf}>Collection Date</div>
              <div className={Styles.merchantHalfRight}>12-07-2024</div>
            </div>
            <div className={Styles.borderLineThree} /> */}

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>Vendor</div>
                  <div className={Styles.merchantHalfRight}>
                    {vehicleData?.MerchantName}
                  </div>
                </div>
                <div className={Styles.borderLineThree} />

                {/* <div className={Styles.merchantRow}>
              <div className={Styles.merchantHalf}>Selected Vehicle(s)</div>
              <div className={Styles.merchantHalfRight}>Autocheck</div>
            </div>
            <div className={Styles.borderLineThree} /> */}

                {/* <div className={Styles.merchantRow}>
              <div className={Styles.merchantHalf}>Invoice Value</div>
              <div className={Styles.merchantHalfRight}>72872872</div>
            </div>
            <div className={Styles.borderLineThree} /> */}

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>Loan Amount</div>
                  <div className={Styles.merchantHalfRight}>
                    {formatAmount(vehicleData?.Amount)}
                  </div>
                </div>
                <div className={Styles.borderLineThree} />

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>Equity Contribution</div>
                  <div className={Styles.merchantHalfRight}>
                    {formatAmount(vehicleData?.EquityContribution)}
                  </div>
                </div>
                <div className={Styles.borderLineThree} />

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>
                    Comprehensive Motor Vehicle Insurance
                  </div>
                  <div className={Styles.merchantHalfRight}>
                    {formatAmount(vehicleData?.VehicleInsurance)}
                  </div>
                </div>
                <div className={Styles.borderLineThree} />

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>Credit Life Insurance</div>
                  <div className={Styles.merchantHalfRight}>
                    {formatAmount(vehicleData?.CreditLifeInsurance)}
                  </div>
                </div>
                <div className={Styles.borderLineThree} />

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>Management Fee</div>
                  <div className={Styles.merchantHalfRight}>
                    {formatAmount(vehicleData?.ManagementFee)}
                  </div>
                </div>
                <div className={Styles.borderLineThree} />

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>Total Upfront Charges</div>
                  <div className={Styles.merchantHalfRight}>
                    {formatAmount(vehicleData?.TotalCharges)}
                  </div>
                </div>
                <div className={Styles.borderLineThree} />

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>Monthly Payment</div>
                  <div className={Styles.merchantHalfRight}>
                    {formatAmount(vehicleData?.MonthlyRepayment)}
                  </div>
                </div>
                <div className={Styles.borderLineThree} />

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>Tenor</div>
                  <div className={Styles.merchantHalfRight}>{vehicleData?.Tenor} Months</div>
                </div>
                <div className={Styles.borderLineThree} />

                {/* <div className={Styles.merchantRow}>
              <div className={Styles.merchantHalf}>Billing/Repayment Date</div>
              <div className={Styles.merchantHalfRight}>12-03-2030</div>
            </div>
            <div className={Styles.borderLineThree} /> */}

                <div className={Styles.merchantRow}>
                  <div className={Styles.merchantHalf}>Vehicle Ownwership</div>
                  <div className={Styles.merchantHalfRight}>
                    Access bank plc/{vehicleData?.Name}
                  </div>
                </div>
                <div className={Styles.borderLineThree} />
              </div>
            }
          </div>
          <button onClick={props.redirect} className={Styles.btn}>
            RETURN TO VEHICLE HISTORY PAGE
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default MerchantInspectionSuccessModal;
